export default __webpack_public_path__ + "static/media/ikara_icon.9921cbb4.svg";